export default __webpack_public_path__ + "static/media/direction-rtl.6593fe2c.svg";